import apiClient from "./apiClient";

const apiServices = async ({
  method = "GET",
  url,
  data = null,
  params = null,
  headers = {},
  useNodeApi = false,
}) => {
  try {
    const config = {
      method,
      url,
      data,
      params,
      headers: { ...headers }
    };

    if (useNodeApi) {
      config.baseURL = process.env.REACT_APP_NODE_API_URL || "http://localhost:8080/api";
      config.headers['X-Use-Bearer'] = true;
    }

    const response = await apiClient(config);

    return {
      success: true,
      statusCode: response.status,
      data: response.data,
      message: "Request successful",
    };
  } catch (error) {
    return {
      success: false,
      statusCode: error.response?.status || 500,
      message: error.response?.data?.message || error.message,
      data: error.response?.data
    };
  }
};

export default apiServices;